
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(0433|4176|9519)|(3621|6154|7239)9|1730|18555|32201|5418|69357|75663|93722)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
